import GroupStatus from "../api/enums/GroupStatus";
import PhotoPlaceholder from "../asset/images/clubsImgs/PhotoPlaceholder.png";
import { PartyModel } from "../types";
import { getClubPhoto } from "./getMedia";

interface PartyClubDisplayInfo {
  clubName: string;
  imageSrc: string;
}

const unknownClubName = "";

const getAcceptedOffer = (party: PartyModel) =>
  party.promotersOffers
    .flatMap((promoterOffer) => promoterOffer.offers)
    .find((offer) => offer.isAccepted);

const getRequestedListingImage = (clubName: string, cityName: string, picture?: string) =>
  picture ||
  getClubPhoto({
    clubName,
    cityName,
  });

export const getPartyClubDisplayInfo = (
  party: PartyModel
): PartyClubDisplayInfo => {
  const acceptedOffer = getAcceptedOffer(party);
  const partyStatus = party.party.status;
  const requestedListings = party.requestedListings;

  if (
    (partyStatus === GroupStatus.Accepted ||
      partyStatus === GroupStatus.Confirmed) &&
    acceptedOffer
  ) {
    return {
      clubName: acceptedOffer.clubName,
      imageSrc: getClubPhoto({
        clubName: acceptedOffer.clubName,
        cityName: party.party.city,
      }),
    };
  }

  if (partyStatus === GroupStatus.Looking && requestedListings.length === 1) {
    const requestedListing = requestedListings[0];

    return {
      clubName: requestedListing.clubName,
      imageSrc: getRequestedListingImage(
        requestedListing.clubName,
        party.party.city,
        requestedListing.picture
      ),
    };
  }

  if (partyStatus === GroupStatus.Looking && requestedListings.length > 1) {
    return {
      clubName: unknownClubName,
      imageSrc: PhotoPlaceholder,
    };
  }

  if (acceptedOffer) {
    return {
      clubName: acceptedOffer.clubName,
      imageSrc: getClubPhoto({
        clubName: acceptedOffer.clubName,
        cityName: party.party.city,
      }),
    };
  }

  if (requestedListings.length > 0) {
    const requestedListing = requestedListings[0];

    return {
      clubName: requestedListing.clubName,
      imageSrc: getRequestedListingImage(
        requestedListing.clubName,
        party.party.city,
        requestedListing.picture
      ),
    };
  }

  return {
    clubName: unknownClubName,
    imageSrc: PhotoPlaceholder,
  };
};

export default getPartyClubDisplayInfo;
